export type SubscriptionStatus = 'active' | 'canceled' | 'past_due' | 'trialing' | 'incomplete';
export type PlanType = 'pro' | 'business';
export type BillingInterval = 'monthly' | 'yearly';

export interface Subscription {
  status: SubscriptionStatus | null;
  plan: PlanType | null;
  interval: BillingInterval | null;
  trialEndsAt: number | null;
  currentPeriodEnd: number | null;
}

export function isActiveSubscription(subscription: Subscription | null | undefined): boolean {
  if (!subscription) return false;

  // Check if subscription is active or in trial
  if (subscription.status !== 'active' && subscription.status !== 'trialing') {
    return false;
  }

  // Check if subscription hasn't expired
  if (subscription.currentPeriodEnd && subscription.currentPeriodEnd < Date.now() / 1000) {
    return false;
  }

  return true;
}
